import { signInWithPopup, connectAuthEmulator } from 'firebase/auth';
import { auth, googleProvider } from './firebaseConfig';

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error("Error during Google sign-in", error);
    throw error;
  }
};

const runtimeConfig = window.__CONFIG__ || {};
const emulatorHost =
  runtimeConfig.REACT_APP_FIREBASE_EMULATOR_HOST ||
  process.env.REACT_APP_FIREBASE_EMULATOR_HOST ||
  'localhost';

if (window.location.hostname === emulatorHost) {
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`);
}

export { auth };
